import * as _ from "lodash";
import { Components } from "formiojs";

const TextFieldComponent = Components.components.textfield;

export default class MiproClinicianOrgTextField  extends TextFieldComponent  {

    static schema() {
        return TextFieldComponent.schema({
            type: "miproClinicianOrgTextField",
            label: "Organisation",
            key: "dbo.mipro.miproClinicianOrg",
            placeholder: "Enter Organisations Name", 
            disabled: false, 
            input: true,
        });
    }

    init() {
        super.init();
    }

    static get builderInfo() {
        return {
            title: "Organisation",
            group: "basic",
            icon: "user-md",
            weight: 70,
            schema: MiproClinicianOrgTextField.schema(),            
        };
    }
}

Components.addComponent("miproClinicianOrgTextField", MiproClinicianOrgTextField);